export function CeleroTerminalCtrl (
  $uibModalInstance,
  sessionObjAPI,
  terminals
) {
  const vm = this;

  vm.terminals = terminals;

  vm.terminal  = vm.terminals.filter(terminal => terminal.id === sessionObjAPI.user().default_pos_terminal_id)[0];

  vm.submit = function () {
    $uibModalInstance.close(vm.terminal);
  };
}
